import React, { FunctionComponent } from 'react';
import Asset from 'src/requests/apa/Asset';

interface ICoach {
    coachImage: string;
    coachName: string;
    roleName: string;
}

interface ICoachProps {
    coachData: ICoach;
}

export const Coach: FunctionComponent<ICoachProps> = (props) => {
    const { coachData } = props;
    const classNameRole = coachData.coachImage ? 'role' : 'only-role';
    return (
        <div className="cont-coach">
            <div className="cont-info">
                
                    <div className="box-img">
                        <img className="img-focusable" src={coachData.coachImage} alt="" />
                    </div>
              
                <div className={classNameRole}>
                    {coachData.coachName && (
                        <span>{`${'Entrenador'}: ${coachData.coachName}`}</span>
                    )}
                </div>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardTeam/coach.tsx